<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="versions"
          item-key="versionId"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Versiones de la App</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                    Nueva Versión
                  </v-btn>
                  <v-btn color="success" dark class="mb-2" @click="ultimaVersion">
                    Ultima Versión
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="form">
                      <v-text-field v-model="version.version" label="Versión"></v-text-field>
                      <v-file-input v-model="version.archivoAPK" label="Archivo APK" prepend-icon="mdi-paperclip"></v-file-input>
                      <v-switch v-model="version.activo" label="Activo"></v-switch>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import srvVersion from '../../services/VersionesApp.service';
export default {
  data() {
    return {
      dialog: false,
      headers: [
        { text: "ID", value: "versionId" },
        { text: "Versión", value: "version" },
        { text: "Activo", value: "activo" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      versions: [],
      version: {
        versionId: null,
        version: "",
        archivoAPK: null,
        activo: false,
      },
    };
  },
  computed: {
    formTitle() {
      return this.version.versionId ? "Editar Versión" : "Nueva Versión";
    },
  },
  methods: {
    async fetchVersions() {
      const response = await srvVersion.ObtenerVersiones();
      this.versions = response.data;
    },
    async ultimaVersion() {
      const url = 'https://gestioniua.blito.ar/api/v1/app/latest'
      const newWindow = window.open(url, '_blank');
      const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "CRUC_IUA_APP.apk"); // Nombre del archivo
        newWindow.document.body.appendChild(link);
        link.click();

        // Eliminar el enlace después de la descarga
        newWindow.document.body.removeChild(link);
    },
    close() {
      this.dialog = false;
    },
    async save() {
      let formData = new FormData();
      formData.append("version", this.version.version);
      formData.append("archivoAPK", this.version.archivoAPK);
      formData.append("activo", this.version.activo);

      if (this.version.versionId) {
        await srvVersion.EditApp(this.version.versionId, formData);
      } else {
        await srvVersion.NewApp(formData);
      }
      this.close();
      this.fetchVersions();
    },
  },
  mounted() {
    this.fetchVersions();
  },
};
</script>

<style>
</style>